import { z } from 'zod'

import type { RequestService } from '../request'
import type { BillingPlan } from '@scalar-org/entities/team'

export function paymentApiFactory(requestService: RequestService) {
  /** Start a stripe payment session */
  async function startSession(
    billingPlan: BillingPlan.ProMonthly | BillingPlan.ProYearly,
  ) {
    return await requestService.request({
      url: 'core/payment/start',
      method: 'post',
      data: {
        billingPlan,
      },
      schema: z.string(),
    })
  }

  /** Start a stripe payment method session */
  async function startBillingSession(data: { paymentMethod?: boolean }) {
    return await requestService.request({
      url: 'core/payment/billing/start',
      method: 'post',
      schema: z.string(),
      data,
    })
  }

  return {
    startSession,
    startBillingSession,
  }
}
